import React from 'react'
import Button from "./Button";
import classNames from 'classnames'
import {ButtonProps} from "./util/ButtonProps";

const OutlinedButton = (props: ButtonProps) => {
  const {className, ...rest} = props
  return <Button className={classNames("ss-button-secondary", className)} {...rest} />
}

export default OutlinedButton
